export interface BuyerRequirement {
  id: string;
  title: string;
  category: string;
  country: string;
  countryFlag: string;
  quantity: string;
  budget: string;
  description: string;
  targetDelivery: string;
  postedAt: string;
  // Hidden from public — only visible to paid factory members
  buyerName: string;
  email: string;
  whatsapp: string;
  company: string;
}

export const mockBuyerRequirements: BuyerRequirement[] = [
  {
    id: "br1",
    title: "Wireless Earbuds — 5,000 Units Bulk Order",
    category: "Electronics",
    country: "United Kingdom",
    countryFlag: "🇬🇧",
    quantity: "5,000 units",
    budget: "$180,000 – $220,000",
    description: "Looking for a verified factory to supply 5,000 units of premium wireless earbuds with ANC. Must have CE certification, IPX5 rating, and Bluetooth 5.0+. OEM branding required. Sample order of 50 units first.",
    targetDelivery: "June 2026",
    postedAt: "2026-04-10",
    buyerName: "James Whitfield",
    email: "james.whitfield@uktech.co.uk",
    whatsapp: "+44 7911 123456",
    company: "UKTech Distribution Ltd.",
  },
  {
    id: "br2",
    title: "Skincare Serum Set — 10,000 Units",
    category: "Beauty",
    country: "Canada",
    countryFlag: "🇨🇦",
    quantity: "10,000 units",
    budget: "$90,000 – $130,000",
    description: "Canadian beauty retailer seeking factory-direct supply of Vitamin C and Hyaluronic Acid serums. Must be cruelty-free, Health Canada compliant. Private label packaging required. Prefer USA local warehouse.",
    targetDelivery: "May 2026",
    postedAt: "2026-04-09",
    buyerName: "Sophie Tremblay",
    email: "sophie@beautycanada.ca",
    whatsapp: "+1 514 555 0192",
    company: "Glow Beauty Canada Inc.",
  },
  {
    id: "br3",
    title: "Fitness Resistance Bands — 20,000 Sets",
    category: "Sports",
    country: "Australia",
    countryFlag: "🇦🇺",
    quantity: "20,000 sets",
    budget: "$120,000 – $160,000",
    description: "Australian fitness equipment distributor needs 5-level resistance band sets. Must pass Australian safety standards. Custom logo printing on bands and packaging. Overseas warehouse shipping acceptable.",
    targetDelivery: "July 2026",
    postedAt: "2026-04-08",
    buyerName: "Liam O'Brien",
    email: "liam@fitaustralia.com.au",
    whatsapp: "+61 412 345 678",
    company: "FitAustralia Wholesale Pty Ltd.",
  },
  {
    id: "br4",
    title: "LED Desk Lamps — 8,000 Units",
    category: "Home",
    country: "Germany",
    countryFlag: "🇩🇪",
    quantity: "8,000 units",
    budget: "$160,000 – $200,000",
    description: "German office supply company looking for smart LED desk lamps with USB-C charging. CE marking required. Must support 220V. White-label branding. Prefer factory with EU export experience.",
    targetDelivery: "August 2026",
    postedAt: "2026-04-07",
    buyerName: "Klaus Müller",
    email: "k.mueller@buerotech.de",
    whatsapp: "+49 151 23456789",
    company: "BüroTech GmbH",
  },
  {
    id: "br5",
    title: "Organic Cotton Hoodies — 15,000 Pieces",
    category: "Fashion",
    country: "France",
    countryFlag: "🇫🇷",
    quantity: "15,000 pieces",
    budget: "$300,000 – $400,000",
    description: "French fashion brand seeking GOTS-certified organic cotton hoodies. Multiple colorways (8 colors), sizes XS–3XL. Custom woven labels and hang tags. Eco-friendly packaging required.",
    targetDelivery: "September 2026",
    postedAt: "2026-04-06",
    buyerName: "Camille Dubois",
    email: "camille@modeparis.fr",
    whatsapp: "+33 6 12 34 56 78",
    company: "Mode Paris SAS",
  },
  {
    id: "br6",
    title: "Bluetooth Speakers — 3,000 Units",
    category: "Electronics",
    country: "Japan",
    countryFlag: "🇯🇵",
    quantity: "3,000 units",
    budget: "$80,000 – $110,000",
    description: "Japanese electronics retailer seeking IPX7 portable Bluetooth speakers. PSE certification required. Japanese language packaging. Prefer factory with Japan export experience and fast turnaround.",
    targetDelivery: "June 2026",
    postedAt: "2026-04-05",
    buyerName: "Kenji Tanaka",
    email: "k.tanaka@techshop.jp",
    whatsapp: "+81 90 1234 5678",
    company: "TechShop Japan Co., Ltd.",
  },
];
